<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
          <h3 class="text-center">Liste des thèmes</h3>
    </div>
  </div>
  <div class="row">
        <p style="text-align:center">Enregistrement(s) : {{ nbTexts.done + ' / ' + (nbTexts.total) + ' (' + (nbTexts.total - nbTexts.done) + ' restants)' }}</p>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-12">
      <button v-if="isAdmin(userRole)" class="btn btn-info btn-sm" type="button" @click="toggleUntoggleUpdate()">Créer un nouveau thème</button>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-striped">
          <thead>
              <tr>
                  <th>Thème</th>
                  <th>Réalisateurs</th>
                  <th>Enregistrements</th>
                  <th>Actions</th>
              </tr>
          </thead>
          <tbody v-if="themes.length">
                  <tr v-for="theme in themes" :key="theme.id">
                      <td v-html="theme.name"></td>
                      <td v-html="theme.reals"></td>
                      <td class="text-center">{{ theme.nbTexts.done + ' / ' + (theme.nbTexts.total) + ' (' + (theme.nbTexts.total - theme.nbTexts.done) + ' restants)' }}</td>
                      <td>
                          <router-link v-if="isAdmin(userRole)" tag="button" class="btn btn-info btn-sm" type="button" :to="'/admin/reals/' + theme.id">Réalisateurs</router-link>
                          <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="'/admin/theme/' + theme.id">Personnages</router-link>
                          <a v-show="theme.nbTexts.done" download :href="themeExportSoundUrl(theme)" class="btn btn-info btn-sm">Export sons</a>
                          <a v-show="theme.nbTexts.total" download :href="themeExportTextUrl(theme)" class="btn btn-info btn-sm">Export textes</a>
                          <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleUpdate(theme)">Editer</button>
                          <button v-if="isAdmin(userRole)" class="btn btn-info btn-sm" type="button" @click="toggleUntoggleDelete(theme)">Supprimer</button>
                      </td>
                  </tr>
          </tbody>
          <tbody v-else>
              <tr>
                  <td>
                      Aucun thème.
                  </td>
              </tr>
          </tbody>
      </table>
      <div class="pager"></div>
    </div>
  </div>

    <modal effect="fade" :title="updateModalTitle" :value="showUpdateModal" :cancel-text="cancelTextModal" :ok-text="updateModalOkText" @ok="updateTheme()" @cancel="toggleUntoggleUpdate()">
        <div class="form-group" @keyup.enter="updateTheme()">
            <label>Nom : </label>
            <bsInput required type="text" name="newTheme" v-model="newThemeName"></bsInput>
            <div style="color:red;" v-if="requiredName">
                Le nom doit être défini.
            </div>
        </div>
    </modal>
    <modal effect="fade" :title="deleteModalTitle" :value="showDeleteModal" cancel-text="Annuler" ok-text="Supprimer" @ok="deleteTheme()" @cancel="toggleUntoggleDelete()">
        <div v-html="deleteModalText">
        </div>
    </modal>
</div>
</template>


<script>
    import { input as BsInput, modal as Modal }  from 'vue-strap'

    export default {
        components: {
            Modal,
            BsInput
        },
        computed: {
            nbTexts: function() {
                return this.$store.state.admin.nbTexts;
            },
            themes: function() {
                return this.$store.state.admin.themes;
            },
            updateModalTitle: function()  {
                if (this.updateModalMode == 'create')  {
                    return "Créer un nouveau thème";
                }
                else  {
                    let name = this.modalTheme.name;
                    return "Editer le thème \"" + name + "\"";
                }
            },
            updateModalOkText: function() {
                if (this.updateModalMode == 'create')  {
                    return "Créer";
                }
                else  {
                    return "Mettre à jour";
                }
            },
            deleteModalTitle: function()  {
                return "Suppression du thème \"" + this.modalTheme.name + "\"";
            },
            deleteModalText: function()  {
                return "Confirmez-vous la suppression du thème \"" + this.modalTheme.name + "\" ?";
            },
            userRole: function() {
                return this.$store.state.role;
            }
        },
        methods: {
            isAdmin(role){
                if (role == "ADMIN") {
                    return true;
                } else {
                    return false;
                }
            },
            themeExportSoundUrl(theme)    {
                return this.$store.state.baseUrl + '/admin/theme/' + theme.id + '/sound-export?token=' + this.$store.state.token;
            },
            themeExportTextUrl(theme)    {
                return this.$store.state.baseUrl + '/admin/theme/' + theme.id + '/text-export?token=' + this.$store.state.token;
            },
            toggleUntoggleUpdate(theme)  {
                this.requiredName = false;
                if (theme)  {
                    this.modalTheme = theme;
                    this.newThemeName = theme.name;
                    this.updateModalMode = 'edit';
                }
                else    {
                    this.updateModalMode = 'create';
                }
                this.showUpdateModal = !this.showUpdateModal;
            },
            toggleUntoggleDelete(theme)  {
                if (theme)  {
                    this.modalTheme = theme;
                }
                this.showDeleteModal = !this.showDeleteModal;
            },
            updateTheme()  {
                if (this.newThemeName != "")    {
                    let textPatch = this.updateModalMode == 'create' ? 'créé' : 'mis à jour';
                    let successCallback = (id) => {
                        this.toggleUntoggleUpdate();
                        this.$store.dispatch('getThemeList', {callbacks: {
                            success: (data) => {
                                this.$store.commit("THEME_LIST_UPDATED", data);
                                this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: 'Le thème «' + this.newThemeName + '» a été ' + textPatch + ' avec succès.',
                                    type: 'success'
                                });
                                this.newThemeName = '';
                            }
                        }});
                    };
                    if (this.updateModalMode == 'create')   {
                        this.$store.dispatch('createTheme', { newThemeName: this.newThemeName,
                                                                callbacks: { success: successCallback,
                                                                             fail: this.toggleUntoggleUpdate,
                                                                             error: this.toggleUntoggleUpdate }
                                                            });
                    }
                    else {
                        this.$store.dispatch('updateTheme', { updatedThemeId: this.modalTheme.id,
                                                                newName: this.newThemeName,
                                                                callbacks: { success: successCallback,
                                                                             fail: this.toggleUntoggleUpdate,
                                                                             error: this.toggleUntoggleUpdate }
                                                            });
                    }
                }
                else    {
                    this.requiredName = true;
                }

            },
            deleteTheme()  {
                let successCallback = () => {
                    this.toggleUntoggleDelete();
                    this.$store.dispatch('getThemeList', {callbacks: {
                        success: (data) => {
                            this.$store.commit("THEME_LIST_UPDATED", data);
                            this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: 'Le thème «' + this.modalTheme.name + '» a été supprimé avec succès.',
                                    type: 'success'
                            });
                            this.$store.commit("THEME_LIST_UPDATED", data);
                        }
                    }});
                };
                this.$store.dispatch('deleteTheme', { themeToDelete: this.modalTheme,
                                                        callbacks: { success: successCallback,
                                                                     fail: this.toggleUntoggleDelete,
                                                                     error: this.toggleUntoggleDelete }
                                                    });
            },
            formatDate(date)  {
                let d = new Date(date);
                return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear() + ' - ' + d.getHours() + ':' + d.getMinutes().toString().padStart(2, "0");
            }
        },
        data: function()  {
            return {
                showUpdateModal: false,
                showDeleteModal: false,
                modalTheme: {
                    name: ''
                },
                newThemeName: '',
                cancelTextModal: "Annuler",
                updateModalMode: 'create',
                requiredName: false
            };
        }
    };
</script>

<style>


</style>
